import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Breadcrumbs,
  Button,
  Content,
  Loading,
} from '@orobix/orobix-fe-components'
import { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import useDriverStyle from '../../components/Driver/driver.styles'
import PageHeader from '../../components/PageHeader/PageHeader'
import { SettingsContext } from '../../components/Settings'
import useUpdateSettings from '../../components/Settings/useUpdateSettings'
import { useDispatch, useStore } from '../../store/store'
import { emptyProducts, fetchProject } from '../../store/storeActions'
import { locations } from '../../utils/locations'
import ButtonNewProduct from './ButtonNewProduct'
import getDriver from './Driver'
import ProductsCreateUpdate from './ProductsCreateUpdate'
import ProductsList from './ProductsList'
import useStyles from './ProductsRoot.styles'

interface RouteParams {
  projectId: string
}

const ProductsRoot = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { project } = useStore()
  const dispatch = useDispatch()
  const { projectId } = useParams<RouteParams>()
  const [productsCreateUpdateModal, setProductsCreateUpdateModal] = useState(
    false
  )
  const classesDriver = useDriverStyle()
  const guidedTourShown = useRef(false)

  useEffect(() => {
    if (!project) {
      fetchProject(dispatch, Number(projectId))
    }

    return () => {
      emptyProducts(dispatch)
    }
  }, [dispatch, project, projectId])

  const { settings } = useContext(SettingsContext)
  const { updateSettings } = useUpdateSettings()

  const updatePreference = () => {
    const checkbox = document.getElementById(
      'doNotShowAgainCheckbox'
    ) as HTMLInputElement
    if (checkbox.checked === settings.preference__show_guided_tour) {
      updateSettings({
        preference__show_guided_tour: !checkbox.checked,
      })
    }
  }

  const driverObj = getDriver(
    classesDriver,
    setProductsCreateUpdateModal,
    settings,
    updateSettings,
    updatePreference,
    productsCreateUpdateModal
  )

  useEffect(() => {
    if (guidedTourShown.current === false) {
      if (settings.preference__show_guided_tour && !driverObj.isActive()) {
        driverObj.drive()
        guidedTourShown.current = true
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings.preference__show_guided_tour])

  return project ? (
    <Content
      breadcrumbs={
        <Breadcrumbs
          elements={[
            <Link to={locations.projects}>{t('Projects')}</Link>,
            project.name,
          ]}
        />
      }
    >
      <PageHeader
        title={t('Products')}
        right={
          <div className={classes.flex}>
            <div id="newProductButtonId" data-testid="newProductButtonId">
              <ButtonNewProduct
                setProductsCreateUpdateModal={setProductsCreateUpdateModal}
              />
            </div>
            <div className={classes.marginRightSm}>
              <Button
                label={t('Explain me how')}
                hideLabel
                icon={<FontAwesomeIcon icon={faCircleQuestion} size="lg" />}
                type="blank-default"
                onClick={() => {
                  driverObj.drive()
                }}
              />
            </div>
          </div>
        }
      />

      <ProductsList />

      {productsCreateUpdateModal && (
        <ProductsCreateUpdate
          setModal={setProductsCreateUpdateModal}
          actionType="create"
          driverObj={driverObj}
        />
      )}
    </Content>
  ) : (
    <Content>
      <Loading />
    </Content>
  )
}

export default ProductsRoot
